/* eslint-disable react/no-danger-with-children */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */
import React, { useEffect } from 'react'
import { Typography, Icon, Button } from 'foundations-library/components'
import { makeStyles } from '@material-ui/core'
import MinimizeIcon from '@material-ui/icons/Minimize'
import phoneGif from '../images/phone.gif'
import { useHistory } from 'react-router-dom'
import { getPhoneCom } from 'phonecom'
import gtmDataPush from 'gtm-events'

/**
 *
 */
const style = (t) => {
    const { colors } = t['foundations-library']
    return {
        popup: {
            position: 'fixed',
            bottom: (props: { showPopup: boolean }) => props.showPopup ? 0 : '-550px',
            right: '28px',
            backgroundColor: '#fff',
            maxWidth: '100%',
            zIndex: 1200,
            width: '500px',
            height: '550px',
            transition: 'bottom 0.5s ease-out',
            boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.12)',
            background: 'linear-gradient(67.17deg, #F2F1F1 7.35%, #F7C78F 53.89%, #FD9A27 101.01%)',
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
            padding: '40px 40px 23px 40px'
        },
        closeIcon: {
            color: '#fff',
            cursor: 'pointer',
            position: 'absolute',
            top: 0,
            right: '15px',
            fontSize: '2.5rem',
            padding: '0.5rem',
            zIndex: 1101,
            opacity: 0.8,
            '&:hover': {
                opacity: 1
            }
        },
        logo: {
            height: '60px',
            width: '60px'
        },
        header: {
            display: 'flex'
        },
        badge: {
            marginLeft: '10px',
            maxWidth: '75px',
            maxHeight: '20px',
            boxShadow: '0px 4px 4px 0px #00000040',
            borderRadius: '8px',
            backgroundColor: '#AADBA0',
            display: 'flex',
            fontSize: '7px',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '7px',
            whiteSpace: 'nowrap',
            fontWeight: 600
        },
        gif: {
            width: '350px',
            height: '200px',
            background: `url(${phoneGif}) round`,
            margin: 'auto',
            marginTop: '25px'
        },
        links: {
            marginTop: '25px',
            marginLeft: '70px',
            width: '310px',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: 'repeat(3, auto)',
            gap: '10px'
        },
        gridItem: {
            borderLeft: `2px solid ${colors.primary[400]}`,
            paddingLeft: '8px',
            display: 'flex',
            alignItems: 'center',
            height: '32px',
            whiteSpace: 'nowrap',
            cursor: 'pointer'
        },
        getButton: {
            minWidth: '70px',
            height: '27px',
            borderRadius: '20px',
            padding: '5px 12px 6px 12px',
            backgroundColor: `${colors.neutral[900]} !important`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }
}

/**
 *
 */
export { style }

const useStyles = makeStyles(style)

/**
 *
 */
const ProsimPromotional = ({ showAppPopup: showPopup, setShowAppPopup: setShowPopup }: { showAppPopup: boolean, setShowAppPopup: React.Dispatch<React.SetStateAction<boolean>> }): JSX.Element => {
    const classes = useStyles({ showPopup })
    const history = useHistory()

    useEffect(() => {
        getPhoneCom().then((phoneCom: Record<string, any>) => {
            const isAdmin = phoneCom?.role === 'account'
            if (isAdmin) {
                const timeout = setTimeout(() => {
                    sessionStorage.getItem('appPopup-closed') !== 'true' && setShowPopup(true)
                }, 3000)

                return () => clearTimeout(timeout)
            }
        })
    }, [])

    const links = [
        { text: 'ProSIM', link: '' },
        { text: 'Duality', link: '' },
        { text: 'Native Dialer', link: '' },
        { text: 'Connected Devices', link: '' },
        { text: 'Secure & Easy', link: '' },
        { text: 'Smart Features', link: '' }
    ]
    return (
        <div className={classes.popup}>
            <MinimizeIcon id={'PROSIM_minimize'} className={classes.closeIcon} onClick={() => {
                setShowPopup(false)
                sessionStorage.setItem('appPopup-closed', 'true')
                gtmDataPush({
                    PDC_Label: 'prosim_app_popup',
                    event: 'prosim_app_popup',
                    action: 'close_prosim'
                })
            }} data-testid='closeIcon' />
            <MinimizeIcon className={classes.closeIcon} onClick={() => { setShowPopup(false); sessionStorage.setItem('appPopup-closed', 'true') }} data-testid='closeIcon' />
            <div style={{ display: 'flex' }}>
                <div>
                    <img
                        className={classes.logo}
                        src="https://s3.us-west-2.amazonaws.com/assets.phone.com/esim-store/app-icon-light-green.png"
                        alt="bg.png"
                        data-testid='esim-logo'
                    />
                </div>
                <div style={{ paddingLeft: '10px' }}>
                    <div style={{ display: 'flex' }}>
                        <Typography data-testid='prosim' variant='h5' color={'neutral-900'}>ProSIM</Typography>
                        <div className={classes.badge}>
                            <Icon name='tag' color='neutral-900' size={10} style={{ marginRight: '6px' }} /> 1 month free
                        </div>
                    </div>
                    <Typography data-testid='enjoy-phone' variant='body1' color={'neutral-900'}>
                        Enjoy all your phone.com enterprise features with ProSIM over a cellular network.
                    </Typography>
                    <Button
                        style={{ marginTop: '20px' }}
                        className={classes.getButton}
                        data-testid='get-button'
                        id={'PROSIM_get_button'}
                        onClick={() => {
                            gtmDataPush({
                                PDC_Label: 'prosim_app_popup',
                                event: 'prosim_app_popup',
                                action: 'get_prosim'
                            })
                            history.push('/apps-marketplace/prosim')
                            setShowPopup(false)
                            localStorage.setItem('appPopup-clicked', 'true')
                        }}
                    >
                        Get
                    </Button>
                </div>
            </div>
            <div className={classes.gif} />
            <div className={classes.links}>
                {links.map((item, index) => (
                    <div key={index} className={classes.gridItem}>
                        <Typography data-testid={`prosim-link-${index}`} variant='buttonLarge' color={'neutral-900'}>{item.text}</Typography>
                        <Icon name='go' color='neutral-900' size={20} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ProsimPromotional
